export default __webpack_public_path__ + "locales/tr/DataReassignmentDialog.json?hash=628c638b089c44035327ad9ed62d20f1";